(() => {
  const openModal = () => {
    const modal = document.querySelector('[data-wholesale-modal]');

    if (!modal) return;

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('dd-wholesale-modal-open');
  };

  const closeModal = () => {
    const modal = document.querySelector('[data-wholesale-modal]');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('dd-wholesale-modal-open');
  };

  /*
   * Open modal from ANY element
   * that has data-wholesale-modal-open
   */
  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-wholesale-modal-open]');

    if (openTrigger) {
      event.preventDefault();
      openModal();
      return;
    }

    /*
     * Close modal
     */
    const closeTrigger = event.target.closest('[data-wholesale-modal-close]');

    if (closeTrigger) {
      closeModal();
    }
  });

  /*
   * Close with ESC
   */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeModal();
    }
  });
})();